var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0492 0C5.42283 0 3.01515e-05 5.4228 3.01515e-05 12.0492C-0.00563474 14.5808 0.787078 17.0497 2.26542 19.1047C3.74376 21.1598 5.83246 22.6964 8.23443 23.496C8.83683 23.5968 9.03723 23.1948 9.03723 22.8936V20.8848C5.72403 21.588 5.02083 19.278 5.02083 19.278C4.51923 17.8728 3.71523 17.4708 3.71523 17.4708C2.51043 16.7676 3.71523 16.7676 3.71523 16.7676C4.92003 16.8684 5.52243 17.9724 5.52243 17.9724C6.62643 19.7796 8.33403 19.278 9.03723 18.9768C9.13803 18.174 9.43923 17.6712 9.84003 17.37C7.12923 17.0688 4.31763 16.0644 4.31763 11.4456C4.31395 10.2633 4.74242 9.12046 5.52243 8.232C5.52243 7.83 5.02083 6.6252 5.72283 5.0184C5.72283 5.0184 6.72723 4.7172 9.03603 6.2232C10.0404 5.922 11.0448 5.8212 12.048 5.8212C13.0512 5.8212 14.0568 5.922 15.06 6.2232C17.37 4.6164 18.3732 5.0184 18.3732 5.0184C19.0764 6.726 18.5736 7.9308 18.474 8.232C19.2768 9.0348 19.6788 10.14 19.6788 11.4456C19.6788 16.0644 16.8672 17.0688 14.1564 17.37C14.5584 17.772 14.9592 18.474 14.9592 19.5792V22.8924C14.9592 23.1936 15.1596 23.5956 15.762 23.4948C18.164 22.6952 20.2527 21.1586 21.731 19.1035C23.2094 17.0485 24.0021 14.5796 23.9964 12.048C24.0996 5.4228 18.6768 0 12.0492 0Z",
    fill: "#868B8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.058af9368a4dae22ccf15099b749f45e.svg";
export { ForwardRef as ReactComponent };